import React from 'react';
import { AppBar, Toolbar } from '@mui/material';

import colors from '@atom/styles/colors';
import layoutStyles from '@atom/styles/layout';

import SearchBar from './search/SearchBar';
import Logo from './Logo';
import NavControls from './NavControls';

const styles = {
  toolBarStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '1rem',
  },
  navBarStyle: {
    height: layoutStyles.topNavHeight,
    backgroundColor: colors.neutral.white,
    boxShadow: '0 2px 4px 1px',
    color: colors.utility.boxShadow,
    position: 'fixed',
    top: 0,
  },
};

interface Props {
  pathname: string;
}

const TopNavigationBar = ({ pathname }: Props) => {
  return (
    <AppBar style={styles.navBarStyle}>
      <Toolbar style={styles.toolBarStyle}>
        <Logo pathname={pathname} />
        <SearchBar />
        <NavControls pathname={pathname} />
      </Toolbar>
    </AppBar>
  );
};

export default TopNavigationBar;
